
import { Component, Vue, Prop, Inject, Provide } from "vue-property-decorator"
import { Wormhole } from "portal-vue"

@Component
export default class ModalPageTarget extends Vue {
	private get hasModalContent () {
		return Wormhole.hasContentFor("modal-page")
	}
}
